
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Container } from "react-bootstrap";
import { QueryChart } from "../../../../component/solution/QueryChart/QueryChart";


export const DashW: React.FC = () => {


    const option1 = {
        title: {
            text: 'Best Sellers 2024'
        },        
        // legend: {},
        tooltip: {
          trigger: 'axis',
          showContent: false
        },
        dataset: {
          source: [
            ['product', '2019', '2020', '2021', '2022', '2023', '2024'],
            ['iPhone', 5600.5, 8200.1, 8800.7, 7000.1, 5300.4, 8500.1],
            ['MacBook', 51.100, 51.400, 5500.1, 5300.3, 7300.8, 6800.7],
            ['iPad', 4000.1, 6200.2, 6900.5, 3600.4, 4500.2, 3200.5],
            ['AirPods', 250.2, 370.1, 410.2, 180, 330.9, 490.1]
          ]
        },
        xAxis: { type: 'category' },
        yAxis: { gridIndex: 0 },
        grid: { top: '55%' },
        series: [
          {
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            emphasis: { focus: 'series' }
          },
          {
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            emphasis: { focus: 'series' }
          },
          {
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            emphasis: { focus: 'series' }
          },
          {
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            emphasis: { focus: 'series' }
          },
          {
            type: 'pie',
            id: 'pie',
            radius: '30%',
            center: ['50%', '25%'],
            emphasis: {
              focus: 'self'
            },
            label: {
              formatter: '{b}: {@2024} ({d}%)'
            },
            encode: {
              itemName: 'product',
              value: '2024',
              tooltip: '2024'
            }
          }
        ]
    };

    const option2 = {
      title: {
          text: 'Current Top 10 for 2024'
      },
      tooltip: {},
      xAxis: {
          data: ['iPhone', 'iPad', 'MacBook', 'Watch S10', 'p5', 'p6', 'p7', 'p8', 'p9', 'p10']
      },
      yAxis: {},
      series: [
          {
              name: 'Sales 2024',
              type: 'bar',
              data: [9000, 7000, 5000, 4800, 2000, 1000, 799, 700, 200, 50]
          }
      ]
  };


    return(
        <React.Fragment>
            <Container fluid className="p-0">
            <div className="d-flex justify-content-center w-100" >
              
                {/* Query Chart Here */}
                  <QueryChart option={option1} />
                  <QueryChart option={option2} />
                {/* Query List Here */}

            </div>

            </Container>
        </React.Fragment>
    );
}